<template>
  <div class="credit-card-list">
    <div
      v-for="(registeredCard, index) in registeredCreditCards"
      :key="index"
      class="radio_btn"
      :class="{
        'check-list-radio-btn': !disabled,
        'check-list-radio-btn-disabled': disabled
      }"
    >
      <input
        :id="`credit3d-${registeredCard.custCode}`"
        v-model="selectedCreditCard"
        type="radio"
        name="payment_method_form[payment_method]"
        :value="`credit3d-${registeredCard.custCode}`"
        :disabled="disabled"
        @change="onChange(`credit3d-${registeredCard.custCode}`)"
      />
      <label :for="`credit3d-${registeredCard.custCode}`" class="radio-label">
        <span class="check-list__credit-card-number">
          {{ registeredCard.creditCardNumber }}
        </span>
        <span class="check-list__credit-card-expired-at">
          有効期限 {{ convertCreditCardExpiredAt(registeredCard.expiredAt) }}
        </span>
        <span
          v-if="!disabled"
          class="check-list__credit-card-delete"
          @click="onClickDelete(registeredCard.custCode)"
        >
          削除
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    registeredCreditCards: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    oldSelectedCreditCard: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      selectedCreditCard: ''
    }
  },
  mounted() {
    this.selectedCreditCard = this.oldSelectedCreditCard
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    },
    onClickDelete(creditCardCustCode) {
      this.$emit('clicked', creditCardCustCode)
    },
    convertCreditCardExpiredAt(date) {
      return dayjs(date).format('MM/YY')
    }
  }
}
</script>
